export const STORE_DEFAULT_PRICE = "__STORE_DEFAULT_PRICE__";
export const ALWAYS_INCLUDED_SELECTION_TYPE = "AlwaysIncluded";